var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"disabled":!_vm.session.subject || _vm.isInMiddleOfFiltering,"outlined":"","label":_vm.$t(
            _vm.interactiveInterfaceFields.messageFieldText === 'Message'
              ? 'Message'
              : 'Sender Details'
          ),"rows":"3","no-resize":"","hide-details":""},on:{"input":_vm.lightSessionRestart},model:{value:(_vm.session.message),callback:function ($$v) {_vm.$set(_vm.session, "message", $$v)},expression:"session.message"}})
}
var staticRenderFns = []

export { render, staticRenderFns }